// Run mount() when el first approaches the viewport — MapLibre/Vega init is
// deferred so the public pages' first paint stays pure HTML/CSS.
export function whenVisible(el, mount) {
  if (!("IntersectionObserver" in window)) return mount()

  const observer = new IntersectionObserver((entries) => {
    if (entries.some((e) => e.isIntersecting)) {
      observer.disconnect()
      mount()
    }
  }, { rootMargin: "300px" })
  observer.observe(el)
}
